const styles = theme => ({
	markdown: {
		fontSize: '15px',
		'& .paragraph': {
			padding: '8px 0'
		},
		'& ul, & ul li, & ol ul > li': {
			listStyle: 'disc'
		},
		'& ol, & ol li, & ul ol > li': {
			listStyle: 'decimal'
		},
		'& ul, & ol': {
			margin: '0px',
			paddingLeft: '20px'
		},
		'& a': {
			wordBreak: 'break-word',
			display: 'inline-block'
		},
		'& h1, & h2, & h3, & h4, & h5, & h6': {
			padding: '6px 0',
			'&:not(:first-child)': {
				padding: '16px 0 6px'
			}
		},
		'& .CodeMirror-fullscreen, & .editor-toolbar.fullscreen, & .editor-preview-side': {
			zIndex: '2000'
		}
	},
	fullScreen: {
		'& .modal-dialog': {
			position: 'absolute',
			top: '0',
			right: '0',
			bottom: '0',
			left: '0',
			width: '100%',
			maxWidth: '100%',
			margin: '0'
		}
	}
});

export default styles;
